import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "text-uppercase" }
const _hoisted_2 = ["colspan", "onClick"]
const _hoisted_3 = { class: "alternative-content" }
const _hoisted_4 = { class: "alternative-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_ProductDetailsDialog = _resolveComponent("ProductDetailsDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("th", { class: "criterion table-head-cell" }, "Criterion", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("th", { class: "aim table-head-cell" }, "Aim", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alternativesIds, (alternativeId) => {
        return (_openBlock(), _createElementBlock("th", {
          key: `alternative-${alternativeId}`,
          colspan: _ctx.subOptionsIds.length,
          class: "alternative table-head-cell",
          onClick: ($event: any) => (_ctx.openProductDialog(alternativeId)),
          style: {"cursor":"pointer"}
        }, [
          _createElementVNode("span", _hoisted_3, [
            (_ctx.state.data?.alternatives?.[alternativeId]?.icon)
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 0,
                  class: "mr-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.state.data.alternatives[alternativeId].icon), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.getAlternatives[alternativeId]?.name || 'Unnamed'), 1),
            (_ctx.hasProductInfo(alternativeId))
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 1,
                  size: "x-small",
                  class: "ml-2 text-info"
                }))
              : _createCommentVNode("", true)
          ])
        ], 8, _hoisted_2))
      }), 128))
    ]),
    _createVNode(_component_ProductDetailsDialog, {
      modelValue: _ctx.showProductDialog,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showProductDialog) = $event)),
      alternative: _ctx.selectedAlternative,
      products: _ctx.state.project?.products || [],
      compositions: _ctx.state.project?.compositions || []
    }, null, 8, ["modelValue", "alternative", "products", "compositions"])
  ], 64))
}